// SEO landing + legal routes (registered before the :seg city catch-all). Landings are bilingual (de + en).
export const LANDING_ROUTES = [
  "zurich-airport-transfer", "taxi-zurich-airport", "zurich-airport-to-zurich",
  "zurich-airport-to-lucerne", "zurich-airport-to-interlaken", "zurich-airport-to-davos",
  "zurich-airport-to-st-moritz", "zurich-airport-to-bern", "zurich-airport-to-basel",
  "zurich-airport-to-zermatt",
  "flughafentransfer-zuerich", "flughafentaxi-zuerich", "zurich-airport-taxi",
  "flughafentaxi-luzern", "flughafentaxi-bern", "flughafentaxi-basel",
  "flughafentaxi-geneve", "flughafentaxi-lausanne", "flughafentaxi-davos",
  "flughafentaxi-st-moritz", "flughafentaxi-zermatt", "flughafentaxi-interlaken",
  "flughafentaxi-lugano", "flughafentaxi-st-gallen",
  "wef-2027", "ski-transfer-schweiz", "flughafentaxi-zug",
  "flughafentaxi-klosters", "flughafentaxi-laax", "zurich-airport-to-geneva",
  "flughafentaxi-arosa", "flughafentaxi-lenzerheide", "flughafentaxi-engelberg", "flughafentaxi-verbier",
  "ski-transfer-st-moritz",
];
// Landings available in more languages than the default de + en.
export const LANDING_LANGS = { "ski-transfer-st-moritz": ["de", "en", "fr", "it"] };
export const landingLangs = (slug) => LANDING_LANGS[slug] || ["de", "en"];
export const LEGAL_ROUTES = ["about", "impressum", "datenschutz", "agb", "stornierung", "privacy", "terms", "cancellation", "imprint"];
